export function validatePassword(value) {
  const length = value.length;
  if (length < 8) {
    return {
      value: value,
      isValid: false,
      message: "Error: Password must be at least eight characters in length.",
    };
  } else if (length > 24) {
    return {
      value: value,
      isValid: false,
      message: "Error: Password can not exceed 24 characters in length.",
    };
  } else if (length >= 8 && length <= 24) {
    // check standard regex pattern
    const FIRSTNET_PASSWORD_PATTERN =
      /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[[\]()!@#^$%&*+_.{}?-]).{8,24}$/;
      // /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[\[\]\(\)!@#^$%&*+_.{}?-]).{8,24}$/; // Unnecessary escape character: \[ \(
    let passwordMatches = FIRSTNET_PASSWORD_PATTERN.test(value);

    if (!passwordMatches) {
      return {
        value: value,
        isValid: false,
        message:
          "Error: Please enter a valid password that has between 8 and 24 character and at least one each of the following : lower case letter, upper case letter, a special character and a number",
      };
    }

    // check for sequential characters/numbers
    var passwordArray = value.split("");
    var ascCount = 1;
    var descCount = 1;
    var char;
    var charCode;
    var prevCharCode;
    var sequenceCheck = true;

    //console.log('pass: ' + value);
    //console.log('passA: ' + passwordArray);
    //console.log('passL: ' + passwordArray.length);

    for (let e in passwordArray) {
      char = passwordArray[e];

      if (!Number.isInteger(char)) {
        charCode = char.toLowerCase().charCodeAt(0);
      } else { 
        charCode = char.charCodeAt(0);
      }

      //console.log(passwordArray[e] + ' : ' + charCode + ' => ' + prevCharCode);

      // ignore special characters codes 32 through 47
      if (charCode < 32 || charCode > 47 ) {
        if (charCode === prevCharCode + 1) {
          ascCount++;
          //console.log('asc Match ' + ascCount);
          if (ascCount === 3) {
            sequenceCheck = false;
            break;
          }
          descCount = 1;
        } else {
          ascCount = 1;
        }

        if (charCode === prevCharCode - 1) {
          descCount++;
          //console.log('desc Match ' + descCount);
          if (descCount === 3) {
            sequenceCheck = false;
            break;
          }
          ascCount = 1;
        } else {
          descCount = 1;
        }
        prevCharCode = charCode;
      } else {
        ascCount = 1;
        descCount = 1;
      }
      
      prevCharCode = charCode;
    };

    if (!sequenceCheck) {
      return {
        value: value,
        isValid: false,
        message:
          "Error: Please enter a valid password that does not contain 3 or more sequential letters or numbers.",
      };
    } else {
      return {
        value: value,
        isValid: true,
        message: "",
      };
    }
  }
}

export default validatePassword;



// WEBPACK FOOTER //
// ./src/helper/validatePassword.js